import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import {connect} from 'react-redux';
import {setCurrentStep, setShowPopUp} from '../changePhoneNumberSlice';
import BtnSubmit from 'app/Components/Shared/Buttons/BtnSubmit';
import {ChangePhoneNumberStep, PopupContent} from '../Constant/Constant';

const PopupWrapper = (props) => {
  function getButtonAction() {
    switch (props.changePhoneNumber.currentPopupData.id) {
      case PopupContent.NotAvailablePopup.id:
        props.setShowPopUp(false);
        props.setCurrentStep(ChangePhoneNumberStep.SelectNewNumber);
        break;

      case PopupContent.ErrorPopup.id:
        props.setShowPopUp(false);
        break;
      default:
        break;
    }
  }

  return (
    <div className='change-phone-number-popup'>
      {props.changePhoneNumber.currentPopupData?.icon && <Image src={props.changePhoneNumber.currentPopupData.icon} />}
      {props.changePhoneNumber.currentPopupData?.title && (
        <div className='l-title' dangerouslySetInnerHTML={{__html: props.changePhoneNumber.currentPopupData.title}} />
      )}
      {props.changePhoneNumber.currentPopupData?.message && (
        <div className='m-title' dangerouslySetInnerHTML={{__html: props.changePhoneNumber.currentPopupData.message}} />
      )}
      <div className='continue-button'>
        <BtnSubmit text={props.changePhoneNumber.currentPopupData?.buttonText} onclick={() => getButtonAction()} />
      </div>
    </div>
  );
};
const mapStateToProps = (state) => ({
  changePhoneNumber: state.changePhoneNumber,
});

const mapDispatchToProps = {
  setCurrentStep,
  setShowPopUp,
};

export default connect(mapStateToProps, mapDispatchToProps)(PopupWrapper);
